import React from 'react'

import { useStateValue } from '@State'
import { DownloadWidget } from './DownloadWidget'

export const ViewOptions = () => {
  const [currentState, dispatch] = useStateValue()
  const percentsClasses = `btn btn-sm btn-default ${
    currentState.isPercentFormat ? 'active' : ''
  }`
  const scoresClasses = `btn btn-sm btn-default ${
    currentState.isPercentFormat ? '' : 'active'
  }`

  return (
    <div className="pull-right">
      <div
        id="viewOptionsContainer"
        className="btn-group"
        data-toggle="buttons"
      >
        <label
          id="viewScoresButton"
          className={scoresClasses}
          onClick={() => {
            dispatch({ type: 'UPDATE_SCORE_FORMAT', payload: false })
          }}
        >
          <input type="radio" name="assessment_view" value="score" />
          View Scores
        </label>
        <label
          id="viewPercentagesButton"
          className={percentsClasses}
          onClick={() => {
            dispatch({ type: 'UPDATE_SCORE_FORMAT', payload: true })
          }}
        >
          <input type="radio" name="assessment_view" value="score" />
          View Percentages
        </label>
      </div>
      <DownloadWidget />
    </div>
  )
}
